import { Box, Button, Paper, Typography } from '@mui/material';
import EmailSentLogo from '../../utils/images/emailSent.svg';
import PasswordCreatedLogo from '../../utils/images/passwordCreated.svg';
import PasswordUpdatedLogo from '../../utils/images/passwordUpdated.svg';
import { useNavigate } from 'react-router-dom';
export const SuccessPage = () => {
  const query = window.location.search;
  const queryObject = new URLSearchParams(query);
  const navigate = useNavigate();
  const originURL = queryObject.get('origin');
  const continueURL = queryObject.get('continue');
  const from = queryObject.get('from');
  const projectID = queryObject.get('id');
  const isFromAeroTrade = originURL?.includes('aerotrade');

  const navigateToLogin = () => {
    const params = new URLSearchParams();

    if (originURL) {
      params.append('origin', originURL);
    }

    if (continueURL) {
      params.append('continue', continueURL);
    }

    const queryString = params.toString();
    const loginURL = queryString ? `/login?${queryString}` : `/login`;

    navigate(loginURL);
  };

  const boxStyle = {
    boxShadow: 'none', // This removes the border
    backgroundColor: '#0000',
    width: '100%',
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: 2,
          marginLeft: 'auto',
          marginRight: 'auto',
          paddingLeft: '20px',
          paddingRight: '20px',
          maxWidth: '420px',
          backgroundColor: 'transparent',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            width: 400,
          }}
          style={boxStyle}
        >
          <>
            <img
              src={
                from === 'verify'
                  ? EmailSentLogo
                  : from === 'reset'
                  ? PasswordUpdatedLogo
                  : PasswordCreatedLogo
              }
              alt="Elevade Email Success"
              className="center-image"
            ></img>
            {from === 'verify' ? (
              <>
                <Typography
                  textAlign={'center'}
                  fontFamily={'ADEFont-SemiBold'}
                  fontSize={24}
                  component="p"
                >
                  Verification email sent!
                </Typography>
                <Typography
                  sx={{
                    fontFamily: 'ADEFont-Regular',
                    fontSize: 16,
                    mb: 1,
                    paddingTop: 1,
                    textAlign: 'center',
                  }}
                >
                  We've sent you a link to verify your account. Please click on the link
                  in your email to get started.
                </Typography>
              </>
            ) : (
              <>
                <Typography
                  textAlign={'center'}
                  fontFamily={'ADEFont-SemiBold'}
                  fontSize={24}
                  component="p"
                >
                  {from === 'verify'
                    ? 'Verification email sent!'
                    : from === 'reset'
                    ? 'Password updated'
                    : 'Password created!'}
                </Typography>
                <Typography
                  sx={{
                    fontFamily: 'ADEFont-Regular',
                    fontSize: 16,
                    mb: 1,
                    paddingTop: 1,
                    textAlign: 'center',
                  }}
                >
                  You have created a new password for{' '}
                  {isFromAeroTrade ? ' AEROTRADE' : ' ELEVADE '}. Please use your new
                  password to log in to your account.
                </Typography>
              </>
            )}
            <Button
              variant="contained"
              type="submit"
              sx={{
                fontFamily: 'ADEFont-SemiBold',
                fontSize: 15,
                marginTop: 4,
                marginBottom: 2,
                height: 56,
                backgroundColor: '#088FD1',
                textTransform: 'none',
                width: '100%',
              }}
              onClick={navigateToLogin}
            >
              {from === 'verify' ? 'Go to Main Page' : 'Log In Now'}
            </Button>
          </>
        </Paper>
      </Box>
    </>
  );
};
